import * as THREE from 'three';

/**
 * Corrige les matériaux d'un modèle importé/généré (ex. Hunyuan 3D) qui exportent un
 * `metalness` proche de 1 par défaut — une valeur de substitution du pipeline de
 * génération, pas une vraie carrosserie métallique. Sans cubemap d'environnement, un
 * matériau quasi entièrement métallique n'a presque aucune réponse à l'éclairage
 * diffus (hémisphère/directionnelle/ambiante) et rend la voiture presque noire. Les
 * pièces du Car Kit (Kenney) utilisent déjà `metalness: 0` et ne sont pas affectées.
 */
export function normalizeCarMaterials(model: THREE.Object3D): void {
  model.traverse((child) => {
    if (!(child instanceof THREE.Mesh)) return;
    const materials = Array.isArray(child.material) ? child.material : [child.material];
    for (const material of materials) {
      if (material instanceof THREE.MeshStandardMaterial && material.metalness > 0.5) {
        material.metalness = 0.1;
      }
    }
  });
}
